/**
 * The build stamp shown by the app version bar (App.vue).
 *
 * `YYYYMMDDHHmm` in UTC from VUE_APP_GIT_COMMIT_TIME (ISO-8601 with offset),
 * or "" when the commit time is missing or unparseable. ABSENT MEANS ABSENT:
 * never `new Date()` (a live clock in the viewer's browser) and never the
 * string "Invalid Date". The long rationale lives with App.vue's callers.
 */
export function formatBuildStamp(raw) {
  if (!raw) return "";
  const at = new Date(raw);
  if (Number.isNaN(at.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return (
    `${at.getUTCFullYear()}` +
    pad(at.getUTCMonth() + 1) +
    pad(at.getUTCDate()) +
    pad(at.getUTCHours()) +
    pad(at.getUTCMinutes())
  );
}

export function buildStamp() {
  return formatBuildStamp(process.env.VUE_APP_GIT_COMMIT_TIME);
}
